import { render, staticRenderFns } from "./commercialAdmin.vue?vue&type=template&id=ec8fcc00"
import script from "./commercialAdmin.vue?vue&type=script&lang=js"
export * from "./commercialAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports